module.exports = {"groups":{"common-questions":"Common questions"},"faqs":{"existe-algun-tipo-de-publicidad-directa-o-indirecta":""}}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en/faqs.json
// module id = 560
// module chunks = 116